import { Breadcrumbs, Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, LinearProgress, Link, List, TextField, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import _ from 'lodash'
import { orderBy } from 'natural-orderby'
import React, { useContext } from 'react'
import { Route, Link as RouterLink, Switch, useParams, useRouteMatch, withRouter } from "react-router-dom"
import Utilities from '../classes/Utilities'
import { CategoryListItem, ClearableTextField, Heading, PackageCard, ProductCard } from '../components'
import { AppContext, withAppContext } from '../context/AppContextProvider'

const styles = (theme) => ({
    breadcrumbs: {
        marginTop: theme.spacing(2),
    },
    loading: {
        marginTop: theme.spacing(2),
    },
    categoryList: {
        marginTop: theme.spacing(1),
    },
    cardGrid: {
        marginTop: theme.spacing(1),
    },
})

class Order extends React.Component {
    state = {
        waits: 1,
        products: [],
        productCategories: [],
        minStock: 0,
        packages: [],
        packageCategories: [],
        searchTerm: '',
        addingGiftCard: false,
    }

    async componentDidMount() {
        await this.getProducts()

        await this.getPackages()

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    getProducts = async () => {
        await this.setState({
            waits: this.state.waits + 1,
        })

        try {
            const { products, categories, minStock } = await this.props.socket.send('order', {
                step: 'getProducts',
            })

            await this.setState({
                products,
                productCategories: categories,
                minStock,
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    getPackages = async () => {
        await this.setState({
            waits: this.state.waits + 1,
        })

        try {
            const { packages, categories } = await this.props.socket.send('order', {
                step: 'getPackages',
            })

            await this.setState({
                packages,
                packageCategories: categories,
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    handleAddToCart = async (item, bulk) => {
        try {
            let itemId = item.id

            // if adding a gift card, display recipient dialog
            if (item.id.startsWith('wylie_egift_card')) {
                this.setState({
                    addingGiftCard: item,
                })
            } else {
                const response = await this.props.socket.send('order', {
                    step: 'modifyItemInCart',
                    type: item.type,
                    itemId,
                    bulk,
                    newQuantity: '+1',
                })

                this.props.showMessage(response, {
                    autoHideDuration: 3000,
                    // eslint-disable-next-line react/display-name
                    action: (key) => <Button color="primary" onClick={() => { this.props.closeSnackbar(key); this.props.history.push(this.props.paths.cart) }}>View Cart</Button>,
                })
            }

        } catch (err) {
            this.props.showError(err)
        }
    }

    handleGiftCardDialogSubmit = async (event) => {
        try {
            event.preventDefault()
            const item = this.state.addingGiftCard

            const response = await this.props.socket.send('order', {
                step: 'modifyItemInCart',
                type: item.type,
                itemId: `${item.id}.${Date.now()}`, // suffix with date to make it a unique line item (prevent qty of 2+)
                bulk: false,
                newQuantity: '+1',
                meta: {
                    recipient: Utilities.getFormValues(event.target),
                }
            })

            await this.setState({
                addingGiftCard: false,
            })

            this.props.showMessage(response, {
                autoHideDuration: 3000,
                // eslint-disable-next-line react/display-name
                action: (key) => <Button color="primary" onClick={() => { this.props.closeSnackbar(key); this.props.history.push(this.props.paths.cart) }}>View Cart</Button>,
            })

        } catch (err) {
            this.props.showError(err)
        }
    }

    render() {
        const { classes, embedOptions, history, match } = this.props
        const { products, packages, productCategories, packageCategories, minStock, searchTerm, addingGiftCard, waits } = this.state
        const categories = _.uniqBy([...productCategories, ...packageCategories], category => category.id)
        const url = match.path
        const searchPattern = new RegExp("(?=.*?\\b" + searchTerm.split(" ").join(")(?=.*?\\b") + ").*", "i")

        return (
            <Container maxWidth="lg">
                {!embedOptions.minimalMode &&
                    <Heading>Order Product</Heading>
                }
                <Grid container justifyContent="space-between" alignItems="flex-end">
                    <Grid className={classes.breadcrumbs} item xs={12} sm={7} md={9} lg={9}>
                        <Switch>
                            <Route path={`${url}`} exact>
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Link component={RouterLink} to={url} color="textPrimary" underline="hover">
                                        Product Categories
                                    </Link>
                                </Breadcrumbs>
                            </Route>
                            <Route path={`${url}/category-:categoryId`}>
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Link component={RouterLink} to={url} color="inherit" underline="hover">
                                        Product Categories
                                    </Link>
                                    {waits == 0 &&
                                        <SelectedCategoryLink categories={categories} />
                                    }
                                </Breadcrumbs>
                            </Route>
                        </Switch>
                    </Grid>
                    <Grid item xs={12} sm={5} md={3} lg={3}>
                        <ClearableTextField
                            name="search"
                            label="Search Category or Product Names"
                            value={searchTerm}
                            fullWidth
                            onInput={(event) => { this.setState({ searchTerm: event.target.value }) }}
                            onClearClick={() => { this.setState({ searchTerm: '' }) }}
                        />
                    </Grid>
                </Grid>
                {waits > 0 &&
                    <LinearProgress className={classes.loading} />
                }
                {waits == 0 &&
                    <Switch>
                        {/* categories */}
                        <Route path={`${url}/`} exact>
                            <List className={classes.categoryList}>
                                <CategoryList
                                    searchPattern={searchPattern}
                                    searchTerm={searchTerm}
                                    categories={categories}
                                    products={products}
                                    packages={packages}
                                    onCategorySelect={(categoryId) => {
                                        history.push(`${url}/category-${categoryId}`)
                                    }}
                                />
                            </List>
                        </Route>

                        {/* products & packages */}
                        <Route path={`${url}/category-:categoryId`}>
                            <Grid className={classes.cardGrid} container spacing={4}>
                                <ItemGrid
                                    searchPattern={searchPattern}
                                    searchTerm={searchTerm}
                                    products={products}
                                    packages={packages}
                                    minStock={minStock}
                                    onAddToCart={this.handleAddToCart}
                                />
                            </Grid>
                        </Route>
                    </Switch>
                }
                <Dialog open={addingGiftCard}>
                    <form onSubmit={this.handleGiftCardDialogSubmit}>
                        <DialogTitle>More Information Required</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Please provide the recipient's name and email address.
                            </DialogContentText>
                                <TextField
                                    variant="standard"
                                    autoFocus
                                    margin="dense"
                                    name="name"
                                    label="Recipient Name"
                                    required
                                    fullWidth
                                />
                                <TextField
                                    variant="standard"
                                    margin="dense"
                                    name="email"
                                    label="Recipient Email Address"
                                    type="email"
                                    required
                                    fullWidth
                                />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => { this.setState({ addingGiftCard: false }) }} color="primary">
                                Cancel
                            </Button>
                            <Button type="submit" color="primary">
                                Continue
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
            </Container>
        )
    }
}

export default withAppContext(withRouter(withStyles(styles, { withTheme: true })(Order)))

function SelectedCategoryLink(props) {
    const { url } = useRouteMatch()
    const { categoryId } = useParams()
    const { categories } = props
    const selectedCategory = categories.find(category => category.id == categoryId)

    return (
        <Link component={RouterLink} to={url} color="textPrimary" underline="hover">
            {selectedCategory.name}
        </Link>
    )
}

function CategoryList(props) {
    const { searchPattern, searchTerm, categories, products, packages } = props

    const matchedCategories = categories.map(category => {
        const matchedItems = [...products, ...packages].filter(item => {
            if (item.category_id !== category.id) {
                return false
            }

            if (!searchTerm.length) {
                return true
            }

            return item.name.match(searchPattern)
        })

        const matchedName = !searchTerm.length ? true : category.name.match(searchPattern)

        return {
            ...category,
            matchedName,
            matchedItems,
        }
    }).filter(category => category.matchedName || category.matchedItems.length)

    if (!matchedCategories.length) {
        return (
            <Typography>There are no products available for ordering online.</Typography>
        )
    }

    return orderBy(matchedCategories, [category => category.name], ['asc']).map(category => {
        const categoryProducts = products.filter(product => {
            return product.category_id == category.id
        })

        const categoryPackages = packages.filter(pkg => {
            return pkg.category_id == category.id
        })

        if (!categoryProducts.length && !categoryPackages.length) {
            return false
        }

        return (
            <CategoryListItem
                key={category.id}
                category={category}
                numItems={category.matchedItems.length}
                searching={searchTerm.length > 0}
                onViewClick={props.onCategorySelect}
            />
        )
    }).filter(category => category !== false)
}

function ItemGrid(props) {
    const { cart } = useContext(AppContext)
    const { categoryId } = useParams()
    const { searchPattern, searchTerm, products, packages, minStock } = props

    const matchedItems = [...products, ...packages].filter(item => {
        if (item.category_id !== categoryId) {
            return false
        }

        if (!searchTerm.length) {
            return true
        }

        return item.name.match(searchPattern)
    })

    if (!matchedItems.length) {
        return (
            <Grid key="n/a" item>
                <Typography>There are no products in this category available for ordering online.</Typography>
            </Grid>
        )
    }

    return orderBy(
        matchedItems,
        [product => product.name],
        ['asc']
    ).map(item => {
        const numIndividualInCart = cart.contents.find(itemInCart => itemInCart.itemId == item.id && itemInCart.bulk == false)?.quantity || 0
        const numBulkInCart = cart.contents.find(itemInCart => itemInCart.itemId == item.id && itemInCart.bulk == true)?.quantity || 0

        if (item.type == 'product') {
            return (
                <Grid key={`prod-${item.id}`} item xs={12} sm={6} md={3}>
                    <ProductCard
                        product={item}
                        numIndividualInCart={numIndividualInCart}
                        numBulkInCart={numBulkInCart}
                        minStock={minStock}
                        onAddToCart={props.onAddToCart}
                    />
                </Grid>
            )
        }

        if (item.type == 'package') {
            return (
                <Grid key={`pkg-${item.id}`} item xs={12} sm={6} md={3}>
                    <PackageCard
                        package={item}
                        onAddToCart={props.onAddToCart}
                    />
                </Grid>
            )
        }
    })
}
